

export const afterListObj = {
  1 :[2,3,4,5,6,10,7,13,15,16,14],
  11 :[2,3,4,5,6,10,7,13,15,16,14],
  12 :[2,3,4,5,6,10,7,13,15,16,14],
  17 :[2,3,4,5,6,18,10,19,20,21,22,23,24],
  18 :[2,3,4,5,6,10,7,13,15,16],
  2 :[2,3,4,5,6,10,7,13,15,16,14],
  4 :[2,3,4,5,6,10,7,13,15,16,14],
  5 :[2,3,4,5,6,10,7,13,15,16,14],
  9 :[2,3,4,5,6,10,7,13,15,16],
  10 :[7,13,15,16],
  7 :[8,99],
  13 :[8],
  15 :[8],
  16 :[8],
};
export const afterListObjBatch = {
  1 :[2,3,4,5,6,10,7,13,15,16,14],
  11 :[2,3,4,5,6,10,7,13,15,16,14],
  12 :[2,3,4,5,6,10,7,13,15,16,14],
  17 :[2,3,4,5,6,18,10,19,20,21,22,23,24],
  18 :[2,3,4,5,6,10,7,13,15,16],
  2 :[2,3,4,5,6,10,7,13,15,16,14],
  4 :[2,3,4,5,6,10,7,13,15,16,14],
  5 :[2,3,4,5,6,10,7,13,15,16,14],
  9 :[2,3,4,5,6,10,7,13,15,16],
  10 :[7,13,15,16],
  7 :[8,99],
  13 :[8],
  15 :[8],
  16 :[8],
};
